import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { desaturate } from 'polished'
import { animated, useSpring } from 'react-spring'
import { springConfig } from 'config/theme'
import { COLORS } from 'config/constants'
import thumbArrows from 'assets/images/thumb_arrows.svg'
import { HANDLE_SIZE } from '../constants'

const StyledHandle = styled(animated.div)`
  position: absolute;
  width: ${HANDLE_SIZE};
  height: ${HANDLE_SIZE};
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: transparent url("${thumbArrows}") center / 60% no-repeat;
  ${({ isDisabled }) => `
    background-color: ${
      isDisabled ? desaturate(0.3, COLORS.CATALAN) : COLORS.CATALAN
    }};
    cursor: ${isDisabled ? 'not-allowed' : 'pointer'};
  `}
  -webkit-tap-highlight-color: ${COLORS.BLACK};
`

const Handle = React.forwardRef(({ handle: { percent }, ...rest }, ref) => {
  const leftAnimation = useSpring({
    left: `${percent || 0}%`,
    ...springConfig,
  })
  return <StyledHandle style={leftAnimation} {...rest} ref={ref} />
})

Handle.propTypes = {
  handle: PropTypes.shape({
    percent: PropTypes.number.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
}

Handle.defaultProps = {
  disabled: false,
}

export default Handle
